import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { useT } from '../i18n/useT';
import { useViewportImage } from '../hooks/useViewportImage';
import { emit } from '../lifecycle/careerHooks';
import { ApplyForm } from '../components/ApplyForm/ApplyForm';
import { api } from '../api';
import { buildApplyFormTranslations } from '../i18n/applyFormTranslations';
import { useTracking, trackEvent } from '../hooks/useTracking';
import { resolveThankyouPath } from '../utils/thankyouRoute';
function navigateToThankyou(config) {
    // B-HPTHANKYOU: determinisztikus feloldás a közös helperből — spontán
    // jelentkezésnél (nincs jobId) a sima kulcs preferált, placeholder-be '0' kerül.
    const path = resolveThankyouPath(config.pages, config.site.slug);
    window.location.href = path || `/${config.site.slug}`;
}
// formTranslations a buildApplyFormTranslations(t) builder-ből jön (i18n/applyFormTranslations.ts)
const HELIT_THEME = {
    primary: '#16435c',
    primaryHover: '#0e2b3d',
    inputBorder: '#cbd5e1',
    inputBorderError: '#dc2626',
    text: '#1e293b',
    textMuted: '#64748b',
    background: '#ffffff',
    headingColor: '#16435c',
    buttonRadius: '6px',
    inputRadius: '6px',
};
export function CvuploadView({ config }) {
    useTracking({ module: 'cvupload' });
    const { t } = useT();
    const [formSections, setFormSections] = useState(null);
    const [formParams, setFormParams] = useState(null);
    // [F-TEXTSUBTYPE] telefon-altípushoz az ország- és HU körzet-lista
    const [phoneLists, setPhoneLists] = useState(null);
    const [isCvMandatory, setIsCvMandatory] = useState(true);
    const [formError, setFormError] = useState(null);
    const [submitError, setSubmitError] = useState(null);
    useEffect(() => {
        emit('cvuploadView', null);
    }, []);
    useEffect(() => {
        if (formSections !== null)
            return;
        api.defaultForm()
            .then((data) => {
            const sections = Array.isArray(data) ? data : (data?.sections || data?.items || []);
            setFormSections(sections);
            setFormParams(data?.params || null);
            if (data?.phone_countries) {
                setPhoneLists({ countries: data.phone_countries, areas: data.phone_hu_areas || [] });
            }
            const mandatory = data?.params?.is_cv_mandatory;
            if (typeof mandatory === 'boolean') {
                setIsCvMandatory(mandatory);
            }
        })
            .catch(err => setFormError(err.message));
    }, [formSections]);
    // Viewport-alapú képkiválasztás: a Jelentkezés oldal saját képe, fallback az Index képeire
    const cvUploadHero = useViewportImage(config.header.cvupload_images);
    const indexHero = useViewportImage(config.header.images);
    const heroImage = cvUploadHero || indexHero;
    const heading = t('cvupload_title', 'Önéletrajz feltöltése');
    return (_jsxs(_Fragment, { children: [_jsx(Header, { config: config }), heroImage && (_jsxs("section", { className: "career-job-header-image", style: { backgroundImage: `url(${heroImage})` }, children: [_jsx("div", { className: "career-job-header-image-overlay" }), _jsx("div", { className: "container mx-auto px-4 relative z-10", children: _jsx("h1", { className: "career-job-header-image-title", "data-translate": "cvupload_title", children: heading }) })] })), _jsxs("main", { className: "container mx-auto px-4 py-8", children: [!heroImage && (_jsx("h1", { className: "text-3xl font-bold mb-6 text-center", "data-translate": "cvupload_title", children: heading })), _jsxs("section", { className: "career-apply-form-wrapper max-w-3xl mx-auto", children: [_jsx("p", { className: "career-apply-form-intro", "data-translate": "cvupload_intro_text", children: t('cvupload_intro_text', 'Jelentkezés adatbázisba') }), formError && (_jsxs("p", { className: "text-red-700 mb-4", children: [_jsx("span", { "data-translate": "error_generic", children: t('error_generic', 'Hiba') }), ": ", formError] })), submitError && (_jsxs("p", { className: "text-red-700 mb-4", children: [_jsx("span", { "data-translate": "error_generic", children: t('error_generic', 'Hiba') }), ": ", submitError] })), !formSections && !formError && (_jsx("p", { className: "text-gray-600", "data-translate": "loading", children: t('loading', 'Betöltés...') })), formSections && (_jsx(ApplyForm, { sections: formSections, params: formParams, phoneCountries: phoneLists?.countries || null, phoneHuAreas: phoneLists?.areas || null, jobId: 0, currentLang: config.language.current, formTranslations: buildApplyFormTranslations(t), thanksRoute: "", basePath: "", isCvShow: true, isCvMandatory: isCvMandatory, themeColors: HELIT_THEME, 
                                // F-2 (2026-05-21): NE hívjon api.apply-t újra - az ApplyForm már intézi a submit-et.
                                // Csak success-re kell tracking + custom navigation. A hibakezelést az ApplyForm
                                // submissionError-on belül mutatja, a JobDetailView-ben már nem duplikáljuk.
                                onApplySuccess: (result) => {
                                    trackEvent('Lead', {
                                        content_category: 'CV upload apply',
                                        content_name: 'Spontaneous apply',
                                        content_ids: ['0'],
                                        value: 1,
                                        currency: 'HUF',
                                    }, 'generate_lead', 'careerLead');
                                    emit('applySuccess', { jobId: 0, result });
                                    navigateToThankyou(config);
                                } }))] })] }), _jsx(Footer, { config: config })] }));
}
